module.exports = __webpack_public_path__ + "static/media/Offered.e3a302a8.png";